import { render, staticRenderFns } from "./FeedbackFloatingButton.vue?vue&type=template&id=53dd655a&scoped=true&"
import script from "./FeedbackFloatingButton.vue?vue&type=script&lang=js&"
export * from "./FeedbackFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackFloatingButton.vue?vue&type=style&index=0&id=53dd655a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd655a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
